export class PeriodModel {

  constructor(public years: number,
              public months: number,
              public days: number) {
  }
}
